const prefix = '/hospital/video/';
const route = [
  {
    path: '/hospital/videointro',
    name: 'VideoIntro',
    component: () => import(/* webpackPrefetchPlaceHolder */ '../inquiryForm/aiGuideNext'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '众安互联网医院',
    keepAlive: true,
  },
  {
    path: '/hospital/videointro/thyroid',
    name: 'aiGuideInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ '../inquiryForm/aiGuideThyroid'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '众安互联网医院',
  },
  {
    path: `${prefix}chat`,
    name: 'VideoChat',
    component: () => import(/* webpackPrefetchPlaceHolder */ './chat'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '众安互联网医院',
  },
];

export default route;
